import { IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';

export const IconFacebook = (props: IconProps) => (
  <svg className={iconStyles(props)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 37">
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M23.424979 10.276143h-2.793544c-.993418 0-1.055317 1.180128-1.055317 1.180128v2.916326h3.476456v4.284178h-3.476456v11.670379h-4.469873v-11.60848H12.68612v-4.346077h2.482023v-4.96506c0-2.980255 3.165949-3.166964 3.165949-3.166964h5.090887v4.03557zM18.499493 0C8.283219 0 0 8.282204 0 18.499493 0 28.71678 8.283219 37 18.499493 37 28.717796 37 37 28.716781 37 18.499493 37 8.282203 28.717796 0 18.499493 0z"
      opacity=".5"
    />
  </svg>
);
